export const COUNT_UP_DURATION = 900;

export const easeOutCubic = (progress: number): number =>
    1 - Math.pow(1 - progress, 3);

// Clamped both ends: a frame delivered past the duration must land exactly on
// the targets, never overshoot them.
export const countUpProgress = (
    elapsed: number,
    duration: number = COUNT_UP_DURATION
): number => (duration <= 0 ? 1 : Math.min(1, Math.max(0, elapsed / duration)));

export const countUpFrame = (
    from: number[],
    targets: number[],
    progress: number
): number[] => {
    const eased = easeOutCubic(progress);

    return targets.map((target, index) => {
        const start = from[index] ?? 0;

        return Math.round(start + (target - start) * eased);
    });
};
